import DynamicInsightsPage from './Page';
export default DynamicInsightsPage;
